import { AddressTypeCodeEnum, Holder, LegalEntity } from "types";

export const getAddressByTypeCode = (holder: Holder | LegalEntity, typeCode: AddressTypeCodeEnum) =>
    holder.addresses && holder.addresses.find((address) => address.addressTypeCode === typeCode);
